import React from 'react';

/**
 * Shared cinematic scene header used by each section.
 */
const SceneHeader = ({ chapter, subtitle, title, description, align = 'left' }) => {
  const alignCls = align === 'center' ? 'items-center text-center mx-auto' : 'items-start';
  return (
    <div className={`flex flex-col ${alignCls} reveal max-w-5xl`}>
      <div className="flex items-center gap-3 text-[10px] uppercase tracking-[0.3em] text-white/45">
        <span className="font-mono text-cyan-400">{chapter}</span>
        <span className="w-10 h-px bg-white/20" />
        <span>Chapter — {subtitle}</span>
      </div>
      <h2 className="mt-6 font-light tracking-[-0.03em] leading-[0.95] text-[44px] md:text-[72px] lg:text-[96px] chromatic-text">
        {title}
      </h2>
      {description && (
        <p className={`mt-6 text-[15px] md:text-base text-white/55 leading-relaxed max-w-xl ${align === 'center' ? 'mx-auto' : ''}`}>
          {description}
        </p>
      )}
    </div>
  );
};

export default SceneHeader;
